import React from "react";
import { Link } from "react-router-dom";
import FrontDev from "../../../images/front-end-tools.png";
import PsdDev from "../../../images/large_Stu04.jpg";
import MernDev from "../../../images/mern.jpg";
import Service from "../Service/Service";
import "./Services.css";

const Services = () => {
    const services = [
        {
            name: "Front End Development",
            desc:
                "I am expert in Front End Development. I can design any kind website using Html5, css3, Bootstrap4, javascript, React Js. Feel free to work with me.",
            img: FrontDev,
        },
        {
            name: "PSD to HTML",
            desc:
                "I am expert in Psd to Html design. I can design any kind website using Html5, css3, Bootstrap4, Material UI, javascript. Feel free to work with me.",
            img: PsdDev,
        },
        {
            name: "MERN Stack Development",
            desc:
                "I can design any kind website using Html5, css3, Bootstrap4, javascript, React Js, Node Js, Express Js and database MongoDB.",
            img: MernDev,
        },
    ];
    return (
        <section className="ms-5">
            <h2 className="service-title">Service I Provide</h2>
            <div className="row mt-5">
                {services.map((service) => (
                    <Service service={service}></Service>
                ))}
            </div>
            <div className="text-center mt-5">
                <Link to="/contact">
                    <button className="button">Contact Me</button>
                </Link>
            </div>
        </section>
    );
};

export default Services;
